import PinService from 'src/common/api/pin.service';
import { LocalStorage } from 'quasar';
import axios from 'axios';
import constants from 'src/common/constants';

export function blockInteraction({ commit }) {
  commit('blockInteraction');
}

export function allowInteraction({ commit }) {
  commit('allowInteraction');
}

export async function validatePin({ commit }, { code }) {
  const response = await PinService.validate({ code });
  if (response.status === 200) {
    commit('setValidPin');
  }
  else {
    commit('setInvalidPin');
  }
}

export async function validateLogOutPin({ commit, dispatch }, { code }) {
  const response = await PinService.validate({ code });

  if (response.status === 200) {
    commit('setValidPin');
    commit('flush');
    dispatch('order/flush', {}, { root: true });
    dispatch('user/flush', {}, { root: true });
    dispatch('product/flush', {}, { root: true });
    dispatch('category/flush', {}, { root: true });
    axios.defaults.headers.common['X-Access-Token'] = constants.DEFAULT_ACCESS_TOKEN;
  }
}

export async function setNotification({ commit }, {
  icon,
  title,
  heading,
  message,
}) {
  commit('setNotification', {
    icon,
    title,
    heading,
    message,
  });
}

export async function clearNotification({ commit }) {
  commit('clearNotification');
}

export async function setValidAge({ commit }) {
  commit('setValidAge');
}

export async function setResetPinDialog({ commit }) {
  commit('setResetPinDialog');
}

export async function clearResetPinDialog({ commit }) {
  commit('clearResetPinDialog');
}

export async function updateLanguage({ commit }, { language }) {
  commit('updateLanguage', { language });
}

export async function updateLanguageFromStorage({ dispatch }) {
  if (LocalStorage.has('language')) {
    dispatch('updateLanguage', { language: LocalStorage.getItem('language') });
  }
}

export async function updateValidPinFromStorage({ commit }) {
  if (LocalStorage.has('pin') && LocalStorage.getItem('pin')) {
    commit('setValidPin');
  }
}

export async function flush({ commit }) {
  commit('flush');
}
